module.exports = __webpack_public_path__ + "img/kongbaiye@2x.eddb346e.png";